import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import AppHomePage from '../pages/AppHomePage';
import AdminDashboard from '../pages/AdminDashboard';

// Import des nouvelles pages (à créer)
import ClientsPage from '../pages/ClientsPage';
import MissionsPage from '../pages/MissionsPage';
import ResourcesPage from '../pages/ResourcesPage';
import ResourceDetailsPage from '../pages/ResourceDetailsPage';
import TicketTrackingPage from '../pages/TicketTrackingPage';

import SettingsPage from '../pages/SettingsPage';
import SupportPage from '../pages/SupportPage'

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route element={<Layout />}>
          {/* Page des consultants après connexion*/}
          <Route path="/home" element={<AppHomePage />} />
          
          {/* Nouvelles Routes Admin */}
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin/clients" element={<ClientsPage />} />
          <Route path="/admin/missions" element={<MissionsPage />} />
          <Route path="/admin/resources" element={<ResourcesPage />} />
          <Route path="/admin/resources/:id" element={<ResourceDetailsPage />} />
          <Route path="/admin/resources/:id/view-as" element={<AppHomePage />} />
          <Route path="/admin/tickettracking" element={<TicketTrackingPage />} />
          {/* Accessible pour les consultants */}
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/support" element={<SupportPage />} />
      </Route>

      <Route path="*" element={<h1>404 Not Found</h1>} />
    </Routes>
  </Router>
);

export default AppRoutes;